import React from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {isAdmin} from '../../../../reducer';
import PrivateRoute from '../../../../components/PrivateRoute';


class AdminRoute extends React.Component {

    render() {

        return (
            <PrivateRoute {...this.props} render={({component: Component, ...props}) => {
                return (
                    isAdmin
                        ? <Component {...props}>{props.children}</Component>
                        : <Redirect to={{pathname: '/', state: {from: props.location}}}/>
                );
            }}/>
        );
    }
}


const mapStateToProps = state => ({
    isAdmin: isAdmin(state)
});


export default connect(
    mapStateToProps
)(AdminRoute)



// WEBPACK FOOTER //
// ./src/scenes/Admin/components/AdminRoute/index.js